import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { Item } from '../../../common/entity/entities';
import { DashboardClient } from '../../../client/dashboard.client';
import { TableBuilder } from 'src/app/common/builder/gs.table.builder';
import { TableTypes } from 'src/app/common/entity/enums';
import { TableColumn } from 'src/app/common/entity/table/tableColumn';

@Component({
  selector: 'payouts-details',
  templateUrl: './payoutsDetails.control.html',
})
export class PayoutsDetailsControl implements OnInit {
  @Input() executeStrategy: (customerCode: number, employeeId: number, businessDate: Date, businessDateTo: Date) => Promise<any>;
  @Input() selectedItem: Item;
  @Input() detailsHeader: string;
  @Input() businessDate: Date;
  @Input() businessDateTo: Date;
  @Input() employeeId: number;
  @Input() customerCode: number;
  @Output() hidePayoutDetails: EventEmitter<void> = new EventEmitter();
  itemName = 'payoutDetails';
  pageSize = 10;
  columns: TableColumn[] = [];

  get item() {
    if (this.selectedItem.items.get(this.itemName))
      return this.selectedItem.items.get(this.itemName);
  }

  ngOnInit() {
    if (!this.businessDateTo) this.businessDateTo = this.businessDate;
    this.columns = TableBuilder.build(TableTypes.Payment_Details);

    this.initiate();
  }

  onDialogClose(isVisible: boolean) {
    if (!isVisible) {
      this.hidePayoutDetails.emit();
    }
  }

  initiate() {
    if (!this.item && this.executeStrategy) {
      this.executeStrategy(
          this.customerCode,
          this.employeeId,
          this.businessDate,
          this.businessDateTo,
        )
        .then((response) => {
          if (response?.result?.length) {
            this.selectedItem.setItem(response?.result, this.itemName);
            response?.result.forEach((val, i) => {
              this.item.setItem(val, i);
            });
          }
        });
    }
  }
}
